class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    console.log('PredictiveSearch initialized, input found:', !!this.input);
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.backdrop = document.querySelector('.predictive-search-backdrop');

  // Toggle to disable predictive search UI/fetching without removing code.
  // Set to `false` to re-enable predictive search later.
  this.disablePredictive = false;
  console.log('disablePredictive:', this.disablePredictive);

    this.setupEventListeners();

    if (this.backdrop) {
      this.backdrop.addEventListener('click', () => this.close());
    }
  }

  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));

    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
  this.close(true);
  if (this.backdrop) this.backdrop.classList.remove('active');
      return;
    }

  // If predictive search is disabled, don't fetch results here.
  if (this.disablePredictive) return;

  this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
      event.preventDefault();
    }
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.close(true); // closes results AND removes backdrop 'active' class
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
  // Prevent default for arrow navigation, but handle Enter manually to allow form submission.
  if (event.code !== 'Enter') event.preventDefault();

    switch (event.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter": {
        // When predictive search is disabled, submit the form to go to the results page.
        const input = this.querySelector("input[type='search'], input[name='q']");
        if (input?.value.trim().length) {
          const form = input.form;
          form?.requestSubmit ? form.requestSubmit() : form.submit();
        }
        break;
      }
    }
  }

  onKeydown(event) {
    if (event.code === "ArrowUp" || event.code === "ArrowDown") {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector("[data-predictive-search-search-for-text]");
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute("open")) return;

    const moveUp = direction === "up";
    const selectedElement = this.querySelector('[aria-selected="true"]');

    const allVisibleElements = Array.from(
      this.querySelectorAll("li, button.predictive-search__item")
    ).filter((element) => element.offsetParent !== null);

    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute("aria-selected", true);
    if (selectedElement) selectedElement.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );
    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
  // Respect disable flag: don't fetch predictive results when disabled.
  if (this.disablePredictive) return;
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    console.log('Fetching predictive search for:', searchTerm);

    if (this.cachedResults[queryKey]) {
      console.log('Using cached results for:', searchTerm);
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=product,article&resources[limit]=7`,
      {
        signal: this.abortController.signal,
      }
    )
      .then((response) => {
        console.log('Predictive search response:', response.status);
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        console.log('Predictive search HTML received, length:', text.length);
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        console.log('Parsed results markup, length:', resultsMarkup.length);
        this.allPredictiveSearchInstances.forEach((instance) => {
          instance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        console.error('Predictive search error:', error);
        if (error?.code === 20) return;
  this.close();
  if (this.backdrop) this.backdrop.classList.remove('active');
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");

    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    // If predictive search disabled, do not render or open dropdown.
    if (this.disablePredictive) return;

    this.predictiveSearchResults.innerHTML = resultsMarkup;
    const hasResults = !!this.predictiveSearchResults.querySelector(
      "#predictive-search-results-groups-wrapper"
    );

    if (hasResults) {
      this.setAttribute("results", true);
      this.setLiveRegionResults();
      this.open();
    } else {
      // No visible groups/results: hide dropdown and ensure backdrop is removed
      this.removeAttribute("results");
      this.setLiveRegionResults();
      this.close(false);
      if (this.backdrop) this.backdrop.classList.remove("active");
    }
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(
      this.querySelector("[data-predictive-search-live-region-count-value]").textContent
    );
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    const hasContent = this.predictiveSearchResults.querySelector(
      ".predictive-search__results-groups-wrapper, .predictive-search__results-list li"
    );
    if (!hasContent) {
      this.close(false);
      return;
    }
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
    if (this.backdrop) this.backdrop.classList.add("active");
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
    if (this.backdrop) this.backdrop.classList.remove("active");
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    const selected = this.querySelector('[aria-selected="true"]');
    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}

if (!customElements.get("predictive-search")) {
  customElements.define("predictive-search", PredictiveSearch);
}

document.addEventListener("click", (e) => {
  const trigger = e.target.closest("[data-search-enter-trigger]");
  if (!trigger) return;
  e.preventDefault();
  const predictive = trigger.closest("form")?.querySelector("predictive-search");
  if (!predictive) return;
  // Use component’s public API if we added it; else inline the logic:
  if (typeof predictive.triggerEnter === "function") {
    predictive.triggerEnter();
  } else {
    const selected = predictive.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (selected) selected.click();
    else {
      const input = predictive.querySelector("input[type='search'], input[name='q']");
      if (input?.value.trim().length) {
        const form = input.form;
        form?.requestSubmit ? form.requestSubmit() : form.submit();
      }
    }
  }
});
